import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { applyTheme } from '@forms/form-render/helpers/applyTheme'
import { initGa4 } from './data/analytics/ga4'
import { trackLandingIfFirstVisit } from './data/analytics/trackLanding'

// Apply theme immediately and also after a frame to ensure it's applied
applyTheme();
initGa4();
trackLandingIfFirstVisit();
requestAnimationFrame(() => {
  applyTheme();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
